import React, { Component } from "react";
import {
  Page,
  PageSection,
  PageBlock,
  PageHeader,
  PageHeaderImage,
  RightDrawer
} from "components/Page";

export default () => {
  return [
    <RightDrawer key="brand_right">
      <PageBlock label="Cookies">
        <p>
          ONESTOP använder cookies för att ge dig bästa möjliga upplevelse av
          Webbplatsen. En cookie är en textfil som sparas på din dator.
        </p>
      </PageBlock>
    </RightDrawer>,
    <Page ready>
      <PageSection>
        <PageBlock header={true} label="Cookiepolicy">
          <p>
            På Webbplatsen används cookies. Cookies är små textfiler som lagras
            på besökarens dator och som är möjliga att använda för att följa vad
            besökaren gör på Webbplatsen.
          </p>
          <p>
            Det finns två typer av cookies: 1) en permanent cookie, som ligger
            kvar på besökarens dator under en bestämd tid, och 2) en
            sessionscookie, som lagras tillfälligt i datorns minne under tiden
            en besökare är inne på en webbsida. Sessionscookies försvinner när
            du stänger din webbläsare. ONESTOP använder cookies för att
            förbättra Webbplatsen för besökaren till exempel genom att anpassa
            webbplatsen efter dina önskemål, val och intressen/säkerställa att
            du loggat in på webbplatsen och därigenom slipper logga in på varje
            ny sida du besöker/ kunna hjälpa dig att hålla reda på vilka
            produkter du valt och för att anpassa våra tjänster i övrigt.
          </p>
          <p>
            Permanenta cookies används bland annat för att lagra dina eventuella
            personliga inställningar hos ONESTOP så att du exempelvis slipper
            göra om vissa val varje gång du besöker webbplatsen. Sessionscookies
            används bland annat i syfte att kunna registrera statistik över
            användandet av webbplatsen, för att ONESTOP ska kunna lära sig mer
            om sina målgrupper samt för att underlätta och spara din navigering
            på Webbplatsen].{" "}
          </p>
          <p>
            Genom att godkänna ONESTOPSs allmänna villkor och använda
            webbplatsen samtycker du till behandlingen av cookies enligt vad som
            sägs här. Om du inte accepterar att cookies används kan du stänga av
            cookies i din webbläsares säkerhetsinställningar. Du kan även ställa
            in webbläsaren så att du får en fråga varje gång webbplatsen
            försöker placera en cookie på din dator. Genom webbläsaren kan också
            tidigare lagrade cookies raderas, se webbläsarens hjälpsidor för mer
            information. Vidare kan du när som helst radera cookies manuellt
            från din hårddisk.
          </p>
          <p>
            Notera att om du väljer att inte acceptera cookies kan
            funktionaliteten komma att begränsas på vissa webbsidor.
          </p>
        </PageBlock>
      </PageSection>
    </Page>
  ];
};



// WEBPACK FOOTER //
// ./src/pages/static/Cookies.jsx